import React from "react";
import styles from "./Loading.module.scss";

/**
 * Reusable Loading Spinner Component.
 *
 * @param {Object} props
 * @param {boolean} [props.isLoading=true] - Whether the loader is active.
 * @param {'fullScreen' | 'overlay' | 'inline'} [props.variant='inline'] - display mode.
 * @param {'small' | 'medium' | 'large'} [props.size='medium'] - Size of spinner.
 * @param {string} [props.message] - Optional message to display below spinner.
 * @param {string} [props.className] - Additional class names.
 */
function Loading({
  isLoading = true,
  variant = "inline",
  size = "medium",
  message,
  className = "",
}) {
  if (!isLoading) return null;

  return (
    <div
      className={`${styles.loadingContainer} ${styles[variant]} ${className}`}
      role="alert"
      aria-busy="true"
    >
      <div className={`${styles.spinner} ${styles[size]}`} />
      {message && (
        <span className={`${styles.message} ${styles[size]}`}>{message}</span>
      )}
    </div>
  );
}

export default Loading;
